import React from "react";
import { FormattedMessage } from "react-intl";
import { margins } from "style";
import { Header } from "components/DisplayBox";
import { H3 } from "components/Text";
import OrganizationSalesOwnerSelector from "./OrganizationSalesOwnerSelector";

/**
 * OrganizationSalesOwner
 */
const OrganizationSalesOwner = ({ ...props }) => (
  <>
    <Header marginSize={margins.normal}>
      <H3>
        <FormattedMessage id="Organizations.OrganizationSalesOwner.Header.Title" />
      </H3>
    </Header>
    <OrganizationSalesOwnerSelector {...props} />
  </>
);

export default OrganizationSalesOwner;
